import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import calendar from 'assets/customerManagement/calendar.svg';
import options from 'assets/customerManagement/options-lines 1.png';
import promotions from 'assets/customerManagement/promotions.svg';
import { getLeadInventory } from 'features/inventory/inventoryActions';
import { selectLeadInventory, selectLoading } from 'features/inventory/inventorySlice';
import Tag from 'pages/components/tag';
import { formatDateTime } from 'utils/dateUtils';

import {
  AddressWrapper,
  CurrentInventoryTitle,
  CustomerInfoWrapper,
  DateItem,
  DateLabel,
  DateList,
  DateSection,
  DatesContainer,
  HeaderPackage,
  Icon,
  Info,
  InventoryCard,
  InventoryCardSvg,
  InventoryCardSvgWrapper,
  InventoryCardWrapper,
  InventoryContentWrapper,
  InventorySection,
  ItemCardsGrid,
  Link,
  PackagePrice,
  PackageStatusWrapper,
  PackageTitle,
  PromotionText,
  PromotionsHeader,
  PromotionsSection,
  Row,
  Title,
} from './Components.styles';
import InventoryFilter from './inventoryFilter/InventoryFilter';

export const CustomerInventory = ({ id }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerInventory = useSelector(selectLeadInventory);
  const loading = useSelector(selectLoading);

  const [filterData, setFilterData] = useState({
    itemName: '',
    categoryName: '',
    createdBy: null,
    providedFromDate: null,
    providedToDate: null,
  });

  useEffect(() => {
    if (id) {
      dispatch(getLeadInventory({ leadUuid: id, params: filterData }));
    }
  }, [dispatch, id, filterData]);

  const items = customerInventory?.inventoryItems || [];

  const handleAppointmentClick = (uuid) => () => {
    navigate(`/my-single-appointments/${uuid}`);
  };
  return (
    <InventorySection>
      <InventoryCardWrapper>
        <InventoryCard borderColor="#bedbff" hoverColor="#2b7fff">
          <InventoryCardSvgWrapper>
            <InventoryCardSvg src={options} />
          </InventoryCardSvgWrapper>
          <div>
            <Title color="#155DFC">Total Items</Title>
            <Info color="#1C398E">{customerInventory?.totalItems ?? '-'}</Info>
          </div>
        </InventoryCard>
        <InventoryCard
          bgColor="linear-gradient(135deg, rgba(243, 232, 255, 0.2) 0%, rgba(152, 16, 250, 0.2) 100%)"
          borderColor="#e9d9fa"
          hoverColor="#9810fa"
        >
          <InventoryCardSvgWrapper bgColor="#9810FA">
            <InventoryCardSvg src={options} />
          </InventoryCardSvgWrapper>
          <div>
            <Title color="#9810FA">Total Categories</Title>
            <Info color="#540090">{customerInventory?.totalCategories ?? '-'}</Info>
          </div>
        </InventoryCard>
        <InventoryCard
          bgColor="linear-gradient(135deg, #F0FDF4 0%, #DCFCE7 100%)"
          borderColor="#B9F8CF"
          hoverColor="#16a34a"
        >
          <InventoryCardSvgWrapper bgColor="#16a34a">
            <InventoryCardSvg src={options} />
          </InventoryCardSvgWrapper>
          <div>
            <Title color="#15C7A7">Last Updated</Title>
            <Info color="#0D542B">
              {customerInventory?.lastUpdated
                ? formatDateTime(customerInventory.lastUpdated, true)
                : '-'}
            </Info>
          </div>
        </InventoryCard>
        <InventoryCard
          bgColor="linear-gradient(135deg, #FFFFFF 0%, #FFDADB 100%)"
          borderColor="#FF9AAE"
          hoverColor="#e11d48"
        >
          <InventoryCardSvgWrapper bgColor="#E63946">
            <InventoryCardSvg src={options} />
          </InventoryCardSvgWrapper>
          <div>
            <Title color="#E63946">Last Updated By</Title>
            <Info color="#7E2A0C">{customerInventory?.lastUpdatedBy || '-'}</Info>
          </div>
        </InventoryCard>
      </InventoryCardWrapper>
      <InventoryContentWrapper>
        <InventoryFilter
          filterData={filterData}
          onFilterChange={setFilterData}
          leadUuid={id}
        />
        <div>
          <CurrentInventoryTitle>Current Equipment</CurrentInventoryTitle>
          {loading.leadInventory ? (
            <p>Loading...</p>
          ) : (
            <ItemCardsGrid>
              {items.map((item, index) => (
                <CustomerInfoWrapper key={item.id ?? index}>
                  <HeaderPackage
                    style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 0 }}
                  >
                    <PackageTitle>
                      <PackageStatusWrapper>
                        <p>{item.itemTypeName || '-'}</p>
                        <Tag type="status" variant={item.isExpired ? 'Expired' : 'Active'} />
                      </PackageStatusWrapper>
                    </PackageTitle>
                    <AddressWrapper>
                      <p>Total Quantity: ({item.leadQuantity} installations)</p>
                    </AddressWrapper>
                  </HeaderPackage>

                  <DatesContainer>
                    <DateSection>
                      <Row>
                        <Icon src={calendar} alt="calendar" />
                        <DateLabel>Installed:</DateLabel>
                      </Row>
                      <DateList>
                        <DateItem>{formatDateTime(item.providedDate, true) || '-'}</DateItem>
                      </DateList>
                    </DateSection>

                    <DateSection>
                      <Row>
                        <DateLabel>Added By:</DateLabel>
                      </Row>
                      <DateList>
                        <DateItem>{item.addedByName || '-'}</DateItem>
                      </DateList>
                    </DateSection>
                    <DateSection>
                      <Row
                        style={{ cursor: 'pointer' }}
                        onClick={handleAppointmentClick(item.appointmentUuid)}
                      >
                        <Icon src={calendar} alt="calendar" />
                        <Link>APT-{item.appointmentUuid}</Link>
                      </Row>
                    </DateSection>
                    {item.note && (
                      <PromotionsSection>
                        <PromotionsHeader>
                          <Icon src={promotions} alt="note" />
                          <p>Note</p>
                        </PromotionsHeader>
                        <PromotionText>{item.note}</PromotionText>
                      </PromotionsSection>
                    )}
                  </DatesContainer>
                </CustomerInfoWrapper>
              ))}
              {items.length === 0 && <p>No items found.</p>}
            </ItemCardsGrid>
          )}
        </div>
      </InventoryContentWrapper>
    </InventorySection>
  );
};
